<template>
	<div id="corporateImage">
		<div class="container" style="position: relative;">
			<div class="shade" v-if="!nextToken"
				style="z-index: 1000;left: 0;top: 0;bottom: 0;right: 0;position: absolute;" @click="toLogin">

			</div>


			<!-- <div class="companyInfo">
				<div class="company_avatar">
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->

			<div class="companyInfoIpt" style="margin-top: 20px;">

				<!-- <div class="onlytitleClass">
					<div class="title">公司信息</div>
				</div> -->
				<div class="titleContainer">
					<div class="shu">
					</div>
					<div class="title">
						公司信息
					</div>
				</div>

				<div class="iptContainer">
					<div class="avatarContainer" style="margin-bottom: 20px;">
						<div class="text"
							style="width: 140px;justify-content:flex-end;display: block;margin-right: 10px;">

							<div class=""
								style="font-weight: 500;font-size: 14px;color: #000;height:82px;line-height: 82px;">
								企业logo：
							</div>
							<!-- <div class="" style="font-weight: 400;font-size: 12px;color: #999;margin-top: 5px;">
                               （建议尺寸1:1）
                            </div> -->
						</div>

						<div class="uploadContainer">
							<div class="upload">
								<el-tooltip class="item" effect="dark" content="点击上传/更换图片，大小不能超过10M" placement="top">
									<el-upload class="avatar-uploader"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess1"
										:before-upload="beforeAvatarUpload">
										<img v-if="logo" :src="logo" class="avatar" style="width: 80px;height: 80px;">
										<div class="avatarUploader" v-else>
											<i class="el-icon-plus avatar-uploader-icon1"></i>
											<span>点击上传</span>
										</div>
									</el-upload>
								</el-tooltip>
							</div>
							<div class="uploadText" style="font-weight: 400;font-size: 12px;color: #999;">
								建议尺寸1：1
							</div>
						</div>
					</div>


					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							企业名称：
						</div>
						<el-input v-model="company_name" disabled placeholder="请输入企业名称"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							<!--  -->
							企业电话：
						</div>
						<el-input v-model="contact_info.tel" maxlength="16" placeholder="请输入企业联系电话"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							<!--  -->
							企业邮箱：
						</div>
						<el-input v-model="contact_info.email" placeholder="请输入企业简历接收邮箱"></el-input>
					</div>

					<!-- <div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							企业官网：
						</div>
						<el-input v-model="contact_info.site" placeholder="请输入企业官网"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							公众号名称：
						</div>
						<el-input v-model="contact_info.wechat" placeholder="请输入企业官方公众号名称"></el-input>
					</div> -->


					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							公司地址：
						</div>
						<div class="environment" @click="openaddressDialogVisible"
							:style="address_arr>0?'color:#606266;':'color:#c0c4cc;'">
							{{address_arr>0?'已添加'+address_arr+'个':'未添加'}}
						</div>
					</div>




					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>所属行业：
						</div>
						<el-select v-model="industry" :multiple-limit='3' multiple placeholder="请选择">
							<el-option v-for="(item,index) in intrdustryList" :key="index" :label="item.untr_desc"
								:value="item.intr_name">
							</el-option>
						</el-select>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>企业简介：
						</div>
						<el-input type="textarea" autosize placeholder="请输入企业简介" v-model="desc">
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							企业文化：
						</div>
						<el-input type="textarea" autosize v-model="corporate_culture" placeholder="请输入企业文化"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							主营业务：
						</div>
						<el-input type="textarea" autosize v-model="manage_scope" placeholder="请输入内容"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							企业性质：
						</div>
						<el-select :multiple-limit='3' v-model="nature" multiple placeholder="请选择">
							<el-option v-for="(item,index) in list7" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							企业标签：
						</div>
						<el-select :multiple-limit="10" allow-create filterable v-model="feature" multiple
							placeholder="请选择（可手动添加）">
							<el-option v-for="(item,index) in list2" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							企业亮点：
						</div>
						<el-input type="textarea" autosize v-model="advantage" placeholder="请输入内容"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>企业规模：
						</div>
						<el-select v-model="scale" placeholder="请选择">
							<el-option v-for="(item,index) in list4" :key="index" :label="item.scale"
								:value="item.scale1">
							</el-option>
						</el-select>
					</div>

					<div class="ipt restTypeIpt" style="margin-bottom: 20px;">
						<div class="text">
							休息方式：
						</div>
						<el-radio-group v-model="restType">
							<el-radio label="双休">双休</el-radio>
							<el-radio label="单休">单休</el-radio>
							<el-radio label="大小休">大小休</el-radio>
							<el-radio label="弹性休息">弹性休息</el-radio>
							<el-radio label="自定义">自定义</el-radio>
						</el-radio-group>
						<el-input v-if="restType === '自定义'" v-model="customRestType" maxlength="10" placeholder="请输入休息方式"
							style="width: 220px;margin-left: 20px;"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							工作时间：
						</div>
						<el-time-select v-model="workingStartTime" placeholder="开始时间"
							:picker-options="{ start: '00:00', step: '00:10', end: '23:50' }"></el-time-select>
						<el-time-select v-model="workingEndTime" placeholder="结束时间" style="margin-left: 10px;"
							:picker-options="{ start: '00:00', step: '00:10', end: '23:50', minTime: workingStartTime }"></el-time-select>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							员工福利：
						</div>
						<el-select v-model="welfare" :multiple-limit="10" allow-create filterable multiple
							placeholder="请选择（可手动添加）">
							<el-option v-for="(item,index) in list3" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>

					<!-- <div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							办公环境：
						</div>
						<el-select v-model="value" multiple filterable placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div> -->

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text">
							办公环境：
						</div>
						<!-- <el-input v-model="officeEnvironment" @click="openEnvironment" 
							placeholder="请输入内容"></el-input> -->
						<div class="environment" @click="openEnvironment" style="cursor: pointer;"
							:style="officeEnvironment=='已添加'?'color:#606266;':'color:#c0c4cc;'">
							{{officeEnvironment}}
						</div>
					</div>


					<!-- <input type="file" > -->

					<!-- 	<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							企业地理位置附近交通、吃喝玩乐介绍：
						</div>
						<el-input type="textarea" autosize placeholder="请输入企业地理位置附近交通、吃喝玩乐介绍"
							v-model="introduction_to_eat">
						</el-input>
					</div> -->
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							人才培养机制：
						</div>
						<el-input type="textarea" autosize placeholder="请输入人才培养机制" v-model="talent_training">
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							行业&公司发展前景：
						</div>
						<el-input type="textarea" autosize placeholder="请输入行业&公司发展前景" v-model="business_development">
						</el-input>
					</div>


					<div class="ipt" style="margin-bottom: 20px; cursor: pointer;">
						<div class="text">
							企业领袖：
						</div>
						<div class="environment" @click="openDialogVisible1" style="cursor: pointer;"
							:style="officeEnvironment1=='已添加'?'color:#606266;':'color:#c0c4cc;'">
							{{officeEnvironment1}}
						</div>
					</div>
					<!-- <div class="ipt" style="margin-bottom: 30px;">
                    	<div class="text">
                    		工作时间：
                    	</div>
                    	<el-select v-model="salary_min" placeholder="请选择上班时间（不选默认8:30-17:30）" @change='changeSalay1'>
                    		<el-option v-for="item in salaryArry1" :key="item.value" :label="item.label"
                    			:value="item.value">
                    		</el-option>
                    	</el-select>
                    
                    	<el-select v-model="salary_max" :placeholder="`请选择下班时间，不选默认（${salary_min}k+）`" v-if="isshow" style="margin-left: 10px;">
                    		<el-option v-for="item in salaryArry2" :disabled='salaryDisabled' :key="item.value"
                    			:label="item.label" :value="item.value">
                    		</el-option>
                    	</el-select>
                    </div> -->



				</div>
				<div class="btnContainer">
					<el-button type="primary" @click="back" v-if="pathStaus">返回</el-button>
					<el-button type="primary" @click="getQrcode">公司预览</el-button>
					<el-button type="primary" @click="save">保存</el-button>
				</div>


				<!-- <el-dialog title="企业领袖" :visible.sync="dialogVisible2" @close='elDialogClose1' width="600px"
					:before-close="handleClose">
					<div class="elDialogContainer">

						<div class="ipt" style="margin-bottom: 20px;">
							<div class="text">
								企业领袖姓名：
							</div>
							<el-input v-model="leaderinfo.lead_name" placeholder="请输入企业领袖姓名"></el-input>
						</div>

						<div class="ipt" style="margin-bottom: 20px;">
							<div class="text">
								企业领袖职务：
							</div>
							<el-input v-model="leaderinfo.lead_position" placeholder="请输入企业领袖职务"></el-input>
						</div>

						<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
							<div class="text">
								企业领袖介绍：
							</div>
							<el-input type="textarea" autosize placeholder="请输入企业领袖介绍" v-model="leaderinfo.txt">
							</el-input>
						</div>

						<div class="ipt" style="margin-bottom: 20px;">
							<div class="text">
								企业领袖头像：
							</div>
							<el-tooltip class="item" effect="dark" content="点击上传/更换图片" placement="right">
								<el-upload class="avatar-uploader1" style="width: 120px;"
									action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
									:show-file-list="false" :on-success="handleAvatarSuccess5"
									:before-upload="beforeAvatarUpload">
									<img v-if="leaderinfoUrl" :src="leaderinfoUrl" class="avatar">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-tooltip>
						</div>
					</div>

					<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
						<el-button type="primary" @click="submit2">保存</el-button>
					</div>
				</el-dialog> -->


				<!-- <el-dialog title="办公环境" :visible.sync="dialogVisible" @close='elDialogClose' width="600px"
					:before-close="handleClose">

				</el-dialog> -->


				<el-dialog title="地址管理" :visible.sync="addressdialogVisible" width="600px" :close-on-click-modal='false'>
					<el-button type="primary" @click="openaddressDialogVisible1()" class="preview">新增地址</el-button>
					<div class="addressList">
						<div class="item" v-for="(item,index) in addressArr" :key="index">
							<div class="addressLeft">
								<div class="top">
									{{item.work_province}}{{item.work_city|cityfilters}}{{item.work_county}}
								</div>
								<div class="bottom">
									{{item.address}}
								</div>
							</div>
							<div class="addressRight" @click="changeAddressIndex(index)">
								<img src="../img/selected.png" alt="" v-if="addressIndex===index" />
								<img src="../img/select.png" alt="" v-else />
							</div>
						</div>
					</div>
					<el-empty description="暂无地址" v-if="addressArr.length==0"></el-empty>
					<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
						<el-button type="danger" @click="deleteAddress" class="preview">删除</el-button>
						<el-button type="primary" @click="addressSubmit" class="preview">确认</el-button>
					</div>
				</el-dialog>

				<el-dialog title="新增地址" :visible.sync="addressdialogVisible1"  width="600px">
					<div class="addressList">
						<div class="ipt" style="margin-bottom: 20px;">
							<div class="text">
								省市区：
							</div>
							<el-cascader v-model="address" placeholder="请选择" :options="addressList" filterable
								:props="{ children:'list',value:'label' }"></el-cascader>
						</div>
						<div class="ipt" style="margin-bottom: 20px;">
							<div class="text">
								详细地址：
							</div>
							<el-input v-model="detailedAddress" placeholder="请输入详细地址"></el-input>
						</div>
					</div>

					<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
						<el-button type="primary" class="preview" @click="submitAddress">确认</el-button>
					</div>

				</el-dialog>



				<div class="previewDialogVisible1">
					<el-dialog :visible.sync="previewDialogVisible" :close-on-click-modal='false' :show-close='false' width="550px"
						class="previewDialogVisible1">
						<div class="previewElDialog">
							<img class="close" @click="previewCloseElDialog" src="../img/close.png" alt="" />
							<div class="main">
								<div class="title">公司预览</div>
								<div class="qrcodeContainer">
									<div class="qrcode">
										<div class="qrcodeImage">
											<img class="qrcodeImg" :src="qrcodeImg" alt="" />
											<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
										</div>

										<div class="hite1">
											扫描<span style="color:#0084FF;">识别二维码</span>
										</div>
										<div class="hite2">
											可在手机上预览公司效果
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-dialog>
				</div>

				<div class="previewDialogVisible1">
					<el-dialog :visible.sync="dialogVisible2" :show-close='false' width="600px" @close='elDialogClose1'
						class="previewDialogVisible1">
						<div class="previewElDialog elDialogContainer"
							style="background: #fff;background: #FFFFFF;border-radius: 10px;padding: 20px 0;">
							<img class="close" @click="dialogVisible2 = false" src="../img/close.png" alt="" />
							<div class=""
								style="line-height: 24px;font-size: 18px;color: #303133;font-weight: bold;padding: 0 20px;margin-bottom: 20px;width: 125px;justify-content: flex-end;">
								企业领袖
							</div>
							<div class="elDialogContainer" style="background: #f7f9ff;padding: 20px 0;">
								<div class="ipt" style="padding: 0 20px;display: flex;">
									<div class="text" style="margin-bottom: 0px;width: 125px;justify-content: flex-end;">
										<span style="color:#FF4A4A">*</span>企业领袖姓名：
									</div>
									<el-input v-model="leaderinfo.lead_name" maxlength="10"
										placeholder="请输入企业领袖姓名"></el-input>
								</div>

								<div class="ipt" style="padding: 0 20px;display: flex;">
									<div class="text" style="margin-bottom: 0px;width: 125px;justify-content: flex-end;">
										企业领袖职务：
									</div>
									<el-input v-model="leaderinfo.lead_position" maxlength="50"
										placeholder="请输入企业领袖职务"></el-input>
								</div>

								<div class="ipt" style="align-items: baseline;padding: 0 20px;display: flex;">
									<div class="text" style="margin-bottom: 0px;width: 125px;justify-content: flex-end;">
										企业领袖介绍：
									</div>
									<el-input type="textarea" autosize placeholder="请输入企业领袖介绍" v-model="leaderinfo.txt">
									</el-input>
								</div>

								<div class="ipt" style="padding: 0 20px;display: flex;">
									<div class="text" style="margin-bottom: 0px;width: 125px;justify-content: flex-end;">
										企业领袖头像：
									</div>
									<div class="enterprise" style="display: flex;align-items: center;">
										<el-tooltip class="item" effect="dark" content="点击上传/更换图片，大小不能超过10M"
											placement="right">
											<el-upload class="avatar-uploader1" style="width: 80px;height: 80px;"
												action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
												:show-file-list="false" :on-success="handleAvatarSuccess5"
												:before-upload="beforeAvatarUpload">
												<img v-if="leaderinfoUrl" :src="leaderinfoUrl" class="avatar5">
												<i v-else class="el-icon-plus avatar-uploader-icon"></i>
											</el-upload>
										</el-tooltip>
										<div class=""
											style="font-size: 14px;color: #999999;margin-right: 20px;margin-left: 20px;">
											<div class="" style="margin-bottom: 5px;">
												建议尺寸1:1，JPG、PNG格式
											</div>
										</div>
									</div>
								</div>

							</div>

							<div class=""
								style="display: flex;align-items: center;justify-content: flex-end;padding: 20px 20px; 0 20px;">
								<el-button type="primary" @click="submit2">保存</el-button>
							</div>

						</div>
					</el-dialog>
				</div>


				<div class="previewDialogVisible1">
					<el-dialog :visible.sync="dialogVisible" @close='elDialogClose' :show-close='false' width="600px"
						class="previewDialogVisible1">
						<div class="previewElDialog elDialogContainer"
							style="background: #fff;background: #FFFFFF;border-radius: 10px;padding: 20px 0;">
							<img class="close" @click="dialogVisible = false" src="../img/close.png" alt="" />
							<div class=""
								style="line-height: 24px;font-size: 18px;color: #303133;font-weight: bold;padding: 0 20px;margin-bottom: 20px;">
								办公环境
							</div>
							<div class="elDialogContainer" style="background: #f7f9ff;padding: 20px 0;">
								<div class="ipt" style="margin-bottom: 20px;padding: 0 20px;">
									<div class="text">
										门头照片：
									</div>
									<div class="" style="display: flex;align-items: flex-end;">
										<el-tooltip class="item" effect="dark" content="点击上传/更换图片，大小不能超过10M"
											placement="right">
											<el-upload class="avatar-uploader1 storefrontSignboard" style="width:120px;"
												action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
												:show-file-list="false" :on-success="handleAvatarSuccess2"
												:before-upload="beforeAvatarUpload"
												:on-preview="handlePictureCardPreview">
												<img v-if="cover_image_url" :src="cover_image_url" class="avatar">
												<i v-else class="el-icon-plus avatar-uploader-icon"></i>

											</el-upload>
										</el-tooltip>

										<div class=""
											style="font-size: 14px;color: #999999;margin-right: 20px;margin-left: 20px;">
											<div class="" style="margin-bottom: 5px;">
												注意事项：
											</div>
											<div class="" style="margin-bottom: 5px;">
												建议图片比例750x560
											</div>
											<!-- <div class="">
												图片大小不超过5000kb
											</div> -->
										</div>
									</div>
								</div>

								<div class="ipt" style="margin-bottom: 20px;padding: 0 20px;">
									<div class="text">
										企业介绍视频：
									</div>
									<div class="" style="display: flex;align-items: flex-end;">
										<el-tooltip class="item" effect="dark" content="点击上传/更换视频" placement="right">
											<el-upload accept=".mp4,.mkv" class="avatar-uploader1" style="width:120px;"
												action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
												:show-file-list="false" :on-success="handleAvatarSuccess4">
												<video v-if="cover_video_url" :src="cover_video_url" :controls='true'
													class="avatar1"></video>
												<i v-else class="el-icon-plus avatar-uploader-icon"></i>
											</el-upload>
										</el-tooltip>
										<div class=""
											style="font-size: 14px;color: #999999;margin-right: 20px;margin-left: 20px;">
											<!-- <div class="" style="margin-bottom: 5px;">
											注意事项：
										</div>
										<div class="" style="margin-bottom: 5px;">
											建议图片比例750x560
										</div>
										<div class="">
											图片大小不超过5000kb
										</div> -->
										</div>
									</div>
									<!-- <video v-if="cover_video_url" :src="cover_video_url" controls class="avatar1"></video> -->
								</div>

								<div class="ipt" style="margin-bottom: 0px;padding: 0 20px;">
									<div class="text" style="display: flex;align-items: baseline;">
										<div class="">
											企业环境：
										</div>
										<div class="" style="color: #999;font-size: 12px;">
											（大小不能超过 10MB）
										</div>
									</div>
									<el-upload action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										list-type="picture-card" :on-preview="handlePictureCardPreview"
										:on-remove="handleRemove" :on-success="handleAvatarSuccess3"
										:before-upload="beforeAvatarUpload" :file-list='fileList'>
										<i class="el-icon-plus"></i>
									</el-upload>

									<div class="preview">
										<el-dialog :visible.sync="dialogVisible1" :modal='false' width="700px">
											<img width="100%" :src="dialogImageUrl" alt="">
										</el-dialog>
									</div>


								</div>

							</div>

							<div class=""
								style="display: flex;align-items: center;justify-content: flex-end;padding: 20px 20px; 0 20px">
								<el-button type="primary" @click="submit1">保存</el-button>
							</div>
						</div>
					</el-dialog>
				</div>


				<el-dialog :visible.sync="mapDialogVisible" title="选择地点" width="600px" :before-close="handleClose" :close-on-click-modal='false'>
					<getMapLocation @selectLocation='selectLocation' @close='close' :addressArr='addressArr'
						@getCompanyInfo='getCompanyInfo'></getMapLocation>
				</el-dialog>

			</div>
		</div>


	</div>
</template>
<script>
	import getMapLocation from '../components/getMapLocation.vue'
	import {
		mapMutations,
		mapState,
		mapActions
	} from 'vuex'
    const config = require('../../WebConfig')
	export default {

		components: {
			getMapLocation,
		},
		data() {
			return {

				mapDialogVisible: false,
				previewDialogVisible: false,
				imageUrl: '',
				name: '',
				textarea1: '',
				options: [{
					value: '男',
					label: '男'
				}, {
					value: '女',
					label: '女'
				}],
				value: '',
				intrdustryList: [{
						"value": 1,
						"intr_name": '互联网/AI/游戏',
						"untr_desc": '互联网/AI/游戏'
					},
					{
						"value": 2,
						"intr_name": '电子/通信/半导体',
						"untr_desc": '电子/通信/半导体'
					},
					{
						"value": 8,
						"intr_name": '制造业（航空/船舶/铁路/设备/机械/化学制品等）',
						"untr_desc": '制造业（航空/船舶/铁路/设备/机械/化学制品等）'
					},{
						"value": 8,
						"intr_name": '汽车（研发制造/网联/零部件/经销等）',
						"untr_desc": '汽车（研发制造/网联/零部件/经销等）'
					},{
						"intr_name": "能源/化工/环保",
						"value": 13,
						"untr_desc": '能源/化工/环保'
					},{
						"intr_name": "房地产/建筑",
						"value": 5,
						"untr_desc": '房地产/建筑'
					},{
						"intr_name": "消费品（食品/服装/家电等）",
						"value": 4,
						"untr_desc": '消费品（食品/服装/家电等）'
					},{
						"intr_name": "制药/医疗/医疗器械",
						"value": 10,
						"untr_desc": '制药/医疗/医疗器械'
					},
					{
						"intr_name": "金融（银行/证券/基金/保险等）",
						"value": 14,
						"untr_desc": '金融（银行/证券/基金/保险等）'
					},{
						"intr_name": "交通运输/物流",
						"value": 12,
						"untr_desc": '交通运输/物流'
					},{
						"intr_name": "教育培训",
						"value": 9,
						"untr_desc": '教育培训'
					},{
						"value": 7,
						"intr_name": '广告/传媒/文化/体育',
						"untr_desc": '广告/传媒/文化/体育'
					},
					{
						"intr_name": "专业服务（咨询/财务/人力资源/法律等）",
						"value": 9,
						"untr_desc": '专业服务（咨询/财务/人力资源/法律等）'
					},
					{
						"intr_name": "服务业（餐饮/美容/酒店/娱乐等）",
						"value": 3,
						"untr_desc": '服务业（餐饮/美容/酒店/娱乐等）'
					},
					{
						"intr_name": "政府/农林牧渔/非盈利机构/其他",
						"value": 15,
						"untr_desc": '政府/农林牧渔/非盈利机构/其他'
					}


				],
				// intrdustryList: [{
				// 	intr_name: '互联网/AI',
				// }, {
				// 	intr_name: '电子/通信/半导体',
				// }, {
				// 	intr_name: '服务业',
				// }, {
				// 	intr_name: '消费品/批发/零售',
				// }, {
				// 	intr_name: '房地产/建筑',
				// }, {
				// 	intr_name: '教育培训',
				// }, {
				// 	intr_name: '广告/传媒/文化/体育',
				// }, {
				// 	intr_name: '制造业',
				// }, {
				// 	intr_name: '专业服务',
				// }, {
				// 	intr_name: '制药/医疗',
				// }, {
				// 	intr_name: '汽车',
				// }, {
				// 	intr_name: '交通运输/物流',
				// }, {
				// 	intr_name: '能源/化工/环保',
				// }, {
				// 	intr_name: '金融',
				// }, {
				// 	intr_name: '政府/非盈利机构/其他',
				// }],

				list7: [
					'上市公司', '国企', '外企', '民企', '股份制企业', '机关/事业单位', '其他'
				],
				list2: [
					'上市企业', '国家级小巨人', '省级专精特新', '国家级单项冠军', '省级单项冠军', '高新技术企业', '科技型中小企业', '独角兽', '央企', '国企', '中国500强',
					'世界500强'
				],
				list3: [
					'五险一金', '带薪年假', '包吃', '包住', '带薪培训', '员工旅游', '团建活动', '免费健身房', '免费班车', '股票期权', '交通补助', '生日福利',
					'节日福利', '通讯补贴', '住房补贴', '零食下午茶', '全勤奖', '底薪加提成', '绩效奖金', '年终奖', '其他'
				],

				list4: [{
					scale: '0-20人',
					scale1: '0-20',
					scale_min: 0,
					scale_max: 20,
				}, {
					scale: '20-99人',
					scale1: '20-99',
					scale_min: 20,
					scale_max: 99,
				}, {
					scale: '100-499人',
					scale1: '100-499',
					scale_min: 100,
					scale_max: 499,
				}, {
					scale: '500-999人',
					scale1: '500-999',
					scale_min: 500,
					scale_max: 999,
				}, {
					scale: '1000-9999人',
					scale1: '1000-9999',
					scale_min: 1000,
					scale_max: 9999,
				}, {
					scale: '1万人以上',
					scale1: '10000-99999',
					scale_min: 10000,
					scale_max: 99999,
				}],
				logo: '', //企业logo
				company_name: '', //企业名称
				contact_info: {
					email: '', //企业简历接收邮箱
					site: '', //企业官网
					wechat: '', //企业官方公众号名称
					tel: '', //企业联系电话
				},

				industry: '', //所属行业
				desc: '', //企业简介
				corporate_culture: '', //企业文化
				manage_scope: '', //主营业务
				nature: '', //企业性质,
				advantage: '', //企业亮点
				feature: '', //企业标签
				scale: '', //企业规模
				restType: '双休', //休息方式
				customRestType: '', //自定义休息方式
				workingStartTime: '08:30', //工作开始时间
				workingEndTime: '17:30', //工作结束时间
				welfare: '', //员工福利

				officeEnvironment: '未添加', //办公环境
				dialogVisible: false,
				cover_image_url: '', //门头
				photo_arr: [], //环境照片
				fileList: [],
				cover_video_url: '', //介绍视频

				introduction_to_eat: '', //企业地理位置附近交通、吃喝玩乐介绍
				business_development: '', //请输入行业&公司发展前景

				dialogImageUrl: '',

				dialogVisible1: false,
				dialogVisible2: false,


				leaderinfo: {
					lead_name: '', //企业领袖名称
					lead_position: '', //领袖岗位
					txt: '', //领袖介绍
					url: [{
						id: 0,
						url: ''
					}]
				},
				leaderinfoUrl: '',
				officeEnvironment1: '未添加',


				addressList: [],
				addressArr: [],
				address: '',
				addressIndex: 0,
				detailedAddress: '',

				addressdialogVisible: false,
				addressdialogVisible1: false,
				address_arr: 0,

				qrcodeImg: '',

				talent_training: '',
				timer: null,
				timer:null,
				pathStaus:0
			};
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		filters:{
			cityfilters(val){
				if(val=='北京市‌'||val=='‌天津市‌‌'||val=='上海市'||val=='重庆市'||val=='澳门特别行政区'||val=='香港特别行政区'){
					return ''
				}
			}
		},
		mounted() {
			this.getCompanyInfo()
			this.remoteMethod()
			console.log(this.$route.query.pathStaus)
			if(this.$route.query.pathStaus){
				this.pathStaus = 1
			}
			// this.getQrcode()
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		methods: {
			...mapActions(['getCompanyUserInfo']),
			...mapMutations(['setIslogin', 'setSchoolData']),
			back(){
				this.$router.push({
					path: '/corporateApply',
				})
			},
			selectLocation(e) {
				console.log(e)
				let repetitionIndex = -1
				this.addressArr.forEach((item, index) => {
					if (item.address == e.address) {
						repetitionIndex = index
					}
				})
				if (repetitionIndex != -1) {
					this.addressArr.splice(repetitionIndex, 1)
				}

				this.addressArr.push({
					address: e.address,
					is_default: 0,
					work_city: e.work_city,
					work_county: e.work_county,
					work_lat: e.work_lat,
					work_lng: e.work_lng,
					work_province: e.work_province,
				})
				this.address_arr = this.addressArr.length
				this.mapDialogVisible = false
			},
			previewCloseElDialog() {
				this.previewDialogVisible = false
			},
			close() {
				this.mapDialogVisible = false
			},
			async getQrcode() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				await this.submit(1)
				this.$util.post(
					`admin/home/qrcode`, {
						app_type: 10,
						not_login: 1,
						page_path: `pages/recruit/companyinfo`,
						id: this.schoolInfo.admin_id,
						is_test: config.IS_TEST
						// app_type: 7,
						// page_path: 'pages/recruit/companyInfo?admin_id=' + this.schoolInfo.admin_id,
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
						this.previewDialogVisible = true
					}
				);
			},
			emailverification() {
				const emailRegex = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i;
				if (emailRegex.test(this.contact_info.email)) {
					return true
				} else {
					this.$message({
						type: 'error',
						message: '请输入正确的企业邮箱'
					});
					return false
				}
			},
			phoneverification() {
				// const phoneRegex = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
				const isPhone = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/ //11位合法手机号码
				const isMob1 = /0\d{2,3}\d{7,8}/ //不带-的座机：02985111752
				const isMob2 = /^([0-9]{3,4}-)?[0-9]{7,8}$/ //带一个-：029-85111752
				const isMob3 = /^\d{3,4}-\d{3,4}-\d{3,4}$/; //带三个-： 0752-250-520
				if (isMob1.test(this.contact_info.tel) || isMob2.test(this.contact_info.tel) || isMob3.test(this
						.contact_info.tel) || isPhone.test(this.contact_info.tel)) {
					return true
				} else {
					this.$message({
						type: 'error',
						message: '请输入正确的企业电话'
					});
					return false
				}
			},
			handleAvatarSuccess1(res) {
				this.logo = res.data.fileUrl;
			},
			handleAvatarSuccess2(res) {
				this.cover_image_url = res.data.fileUrl;
			},
			openEnvironment() {
				this.dialogVisible = true
			},
			handleClose(done) {
				done();
			},

			openaddressDialogVisible() {
				this.addressdialogVisible = true
			},
			openaddressDialogVisible1() {
				// this.addressdialogVisible1 = true
				this.mapDialogVisible = true
			},

			changeAddressIndex(index) {
				this.addressIndex = index
				this.addressdialogVisible1 = false
			},

			//获取城市列表
			remoteMethod() {
				this.$util.get1(
					"https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2022/12/28/arealist.json?0.4693243637069089", {},
					(res) => {

						this.addressList = res.data
					}
				);
			},
			submitAddress() {

				this.addressArr.push({
					address: this.detailedAddress,
					is_default: 0,
					work_city: this.address[1].indexOf('市') == -1 ? this.address[1] + '市' : this.address[1],
					work_county: this.address[2],
					work_lat: 0,
					work_lng: 0,
					work_province: this.address[0].indexOf('省') == -1 ? this.address[0] + '省' : this.address[0],
				})
				this.addressdialogVisible1 = false
				this.address = ''
				this.detailedAddress = ''
			},

			handleRemove(file, fileList) {
				this.fileList = fileList
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible1 = true;
			},

			handleAvatarSuccess3(response, file, fileList) {



				// [{url:'',id:0}]
				this.fileList = fileList
			},
			handleAvatarSuccess4(res) {
				this.cover_video_url = res.data.fileUrl;
			},


			elDialogClose() {
				if (this.cover_image_url != '' || this.fileList.length > 0 || this.cover_video_url != '') {
					this.officeEnvironment = '已添加'
				} else {
					this.officeEnvironment = '未添加'
				}
			},

			beforeAvatarUpload(file) {

				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB!');
					return
				}

				return isLt2M && img;
			},


			handleAvatarSuccess5(res) {

				this.leaderinfoUrl = res.data.fileUrl;
				this.leaderinfo.url[0].url = res.data.fileUrl
			},
			openDialogVisible1() {
				this.dialogVisible2 = true
			},


			elDialogClose1() {

				// if (this.leaderinfo.lead_name != '' || this.leaderinfo.lead_position != '' || this.leaderinfo.txt != '' ||
				// 	this.leaderinfo.url[0].url != '') {
				// 	this.officeEnvironment1 = '已添加'
				// } else {
				// 	this.officeEnvironment1 = '未添加'
				// }
			},

			getCompanyInfo() {
				this.$util.post(
					"v2/school_job/getCompanyInfo", {
						admin_id: this.schoolInfo.admin_id,
					},
					(res) => {

						if (res.code == 200) {

							this.setSchoolData(res.data)
							this.logo = res.data.logo
							this.company_name = res.data.company_name
							let contact_info = {}
							if (res.data.contact_info != '') {
								contact_info = JSON.parse(res.data.contact_info)
							}
							console.log(!contact_info)
							if (res.data.email) {
								if(!contact_info.email){
									if (contact_info.email=='') {
										contact_info.email = ''
									}else{
										contact_info.email = res.data.email
									}
								}
							}
							this.contact_info = contact_info
							if (res.data.industry != '') {
								this.industry = res.data.industry.split(',')
							}
							this.desc = res.data.desc
							this.corporate_culture = res.data.corporate_culture
							this.manage_scope = res.data.manage_scope

							if (res.data.nature != '' && res.data.nature != '-') {
								this.nature = res.data.nature.split(',')
							}
							this.advantage = res.data.advantage
							if (res.data.feature != '' && res.data.feature != '-') {
								this.feature = res.data.feature.split(',')
							}
							this.scale = res.data.scale.replace('人', '')

							if (res.data.welfare != '') {
								this.welfare = res.data.welfare.split(',')
							}
							this.restType = '双休'
							this.customRestType = ''
							if (res.data.rest_schedule) {
								if (['双休', '单休', '大小休', '弹性休息'].includes(res.data.rest_schedule)) {
									this.restType = res.data.rest_schedule
								} else {
									this.restType = '自定义'
									this.customRestType = res.data.rest_schedule
								}
							}
							this.workingStartTime = '08:30'
							this.workingEndTime = '17:30'
							if (res.data.work_time) {
								let workTime = res.data.work_time.split('-')
								this.workingStartTime = workTime[0] || ''
								this.workingEndTime = workTime[1] || ''
							}
							this.cover_image_url = res.data.cover_image_url || ''
							this.photo_arr = res.data.photo_arr || []
							this.fileList = res.data.photo_arr || []
							this.cover_video_url = res.data.cover_video_url || ''

							if (res.data.address_arr) {
								this.address_arr = res.data.address_arr.length
							}


							if ((res.data.cover_image_url && res.data.cover_image_url != '') || (res.data.photo_arr &&
									res.data.photo_arr
									.length > 0) || (res.data.cover_video_url && res.data.cover_video_url != '')) {
								this.officeEnvironment = '已添加'
							} else {
								this.officeEnvironment = '未添加'
							}

							this.introduction_to_eat = res.data.introduction_to_eat
							this.business_development = res.data.business_development
							this.talent_training = res.data.talent_training
							if (res.data.business_leaders && res.data.business_leaders != '') {
								this.leaderinfo = JSON.parse(res.data.business_leaders)
								this.leaderinfoUrl = JSON.parse(res.data.business_leaders).url[0].url
							}


							if (this.leaderinfo.lead_name != '' || this.leaderinfo.lead_position != '' || this
								.leaderinfo.txt != '' || this.leaderinfo.url[0].url) {
								this.officeEnvironment1 = '已添加'
							} else {
								this.officeEnvironment1 = '未添加'
							}

							if (res.data.address_arr) {
								this.addressArr = res.data.address_arr
							}
						}
					}
				);
			},
			toLogin() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
			},
			// https://np.sx985.com/v2/school_job/editCompany
			async save() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '确去登录定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				await this.submit(0)
			},
			submit(idx) {
				return new Promise((resolve) => {
					console.log(this.contact_info)
					if (this.contact_info.tel && this.contact_info.tel != '') {
						if (!this.phoneverification()) {
							return
						}
					}

					if (this.contact_info.email && this.contact_info.email != '') {
						if (!this.emailverification()) {
							return
						}
					}



					if (this.industry.length == 0) {
						this.$message.error('请选择行业');
						return
					}
					if (!this.scale && this.scale != '-') {
						this.$message.error('请选择企业规模');
						return
					}
					if (!this.desc) {
						this.$message.error('请输入企业简介');
						return
					}
					let obj = {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
					}
					obj.logo = this.logo
					obj.company_name = this.company_name

					obj.contact_info = JSON.stringify(this.contact_info)
					obj.email = this.contact_info.email
					if (this.industry !== '') {
						obj.industry = this.industry.join(',')
					} else {
						obj.industry = ''
					}
					obj.desc = this.desc;
					obj.advantage = this.advantage
					obj.corporate_culture = this.corporate_culture
					obj.manage_scope = this.manage_scope

					if (this.nature !== '') {
						obj.nature = this.nature.join(',')
					} else {
						obj.nature = ''
					}
					if (obj.nature === '') {
						obj.nature = '-'
					}
					console.log("featurefeature", this.feature);
					if (this.feature !== '') {
						obj.feature = this.feature.join(',')
					} else {
						obj.feature = ''
					}
					if (obj.feature === '') {
						obj.feature = '-'
					}
					// obj.nature = this.nature.join(',')
					// obj.feature = this.feature.join(',')
					obj.scale = this.scale
					if (this.scale && this.scale != '') {
						obj.scale_max = this.scale.split('-')[1]
						obj.scale_min = this.scale.split('-')[0]
					}
					obj.welfare = this.welfare.join(',')
					obj.rest_schedule = this.restType === '自定义' ? this.customRestType : this.restType
					obj.work_time = this.workingStartTime && this.workingEndTime ? `${this.workingStartTime}-${this.workingEndTime}` : ''
					obj.cover_image_url = this.cover_image_url
					let fileList = []
					// this.fileList.forEach((item) => {
					// 	if (item.response) {
					// 		fileList.push({
					// 			id: 0,
					// 			url: item.response.data.fileUrl
					// 		})
					// 	} else {
					// 		fileList.push({
					// 			id: 0,
					// 			url: item.url
					// 		})
					// 	}

					// })
					obj.photo_arr = JSON.stringify(this.photo_arr)
					obj.cover_video_url = this.cover_video_url
					obj.introduction_to_eat = this.introduction_to_eat
					obj.business_development = this.business_development
					obj.talent_training = this.talent_training
					obj.business_leaders = JSON.stringify({
						...this.leaderinfo,
						url: [{
							url: this.leaderinfoUrl,
						}]
					})
					obj.address_arr = JSON.stringify(this.addressArr)


					this.$util.post(
						"v2/school_job/editCompany", {
							...obj
						},
						(res) => {

							if (res.code == 0) {
								if (idx == 0) {
									this.$message({
										message: '保存成功',
										type: 'success',
										duration:1000
									});
								}
								this.getCompanyInfo()
								this.getCompanyUserInfo()
								
								resolve()
							} else {
								this.$message.error(res.msg);
							}
							resolve()
						})
				})
			},


			submit1() {
				let arr = []

				this.fileList.forEach((item) => {
					if (item.response) {
						arr.push({
							url: item.response.data.fileUrl,
							id: 0,
						})
					} else {
						arr.push({
							url: item.url,
							id: 0,
						})
					}
				})

				this.photo_arr = arr

				this.dialogVisible = false
			},
			submit2() {
				if (this.leaderinfo.lead_name.trim() == '') {
					this.$message({
						message: '请输入企业领袖姓名',
						type: 'error'
					});
					return
				}
				this.leaderinfo.lead_name = this.leaderinfo.lead_name.trim()
				this.leaderinfo.lead_position = this.leaderinfo.lead_position.trim()
				this.leaderinfo.txt = this.leaderinfo.txt.trim()

				this.dialogVisible2 = false

				if (this.leaderinfo.lead_name != '' || this.leaderinfo.lead_position != '' || this
					.leaderinfo.txt != '' || this.leaderinfo.url[0].url) {
					this.officeEnvironment1 = '已添加'
				} else {
					this.officeEnvironment1 = '未添加'
				}
			},
			
			async addressSubmit() {
				if (await this.isDebounce()) return;
				if (this.addressArr.length > 0) {
					this.addressdialogVisible = false
				} else {
					this.$message({
						message: '请选择地址',
						type: 'error'
					});
				}

			},
			isDebounce(duration = 500) {
				return new Promise(resolve => {
					// 如果已有定时器，清除（重新计时）
					if (this.timer) {
						clearTimeout(this.timer);
					}
					// 开启新定时器
					this.timer = setTimeout(() => {
						resolve(); // 时间到 → 放行
					}, duration);
				});
			},
			async deleteAddress() {
				if (await this.isDebounce()) return;
				if (this.addressArr.length > 0) {
					let obj = {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
					}
					this.addressArr.splice(this.addressIndex, 1)
					obj.address_arr = JSON.stringify([
						...this.addressArr,
					])
					this.$util.post(
						"v2/school_job/editCompany", {
							...obj
						},
						(res) => {

							if (res.code == 0) {
								this.$message({
									message: '删除成功',
									type: 'success'
								});
								this.getCompanyInfo()
								this.addressIndex = 0
							}
						})
				} else {
					this.$message({
						message: '请选择地址',
						type: 'error'
					});
				}


			},
		},
	};
</script>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				// background: #003987;
				margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.companyInfoIpt {
			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}
			}

			.iptContainer {

				.avatarContainer {
					width: 750px;
					display: flex;
					// align-items: center;
					align-items: flex-start;
					margin-bottom: 30px;

					.text {
						width: 100px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						margin-right: 5px;
						text-align: right;
					}

					.upload {
						margin-right: 20px;
					}

					.uploadContainer {
						display: flex;
						align-items: center;

						.uploadText {
							width: 310px;
							font-weight: 500;
							font-size: 14px;
							color: #999999;
						}
					}

				}

				.ipt {
					width: 750px;
					display: flex;
					align-items: center;
					margin-bottom: 28px;

					&.restTypeIpt {
						min-height: 40px;
					}

					.text {
						width: 140px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						margin-right: 10px;
						// position: relative;
						justify-content: flex-end;

						span {
							// position: absolute;
							// left: -10px;

						}
					}

					.el-input {
						flex: 1 !important;
					}

					.el-select {
						flex: 1 !important;
					}

					.el-textarea {
						flex: 1 !important;
					}

					video {
						width: 140px;
						height: 140px;
					}
				}

			}

			.btnContainer {
				width: 750px;
				display: flex;
				justify-content: flex-end;
				margin-bottom: 60px;

				.el-button--primary {
					// background-color: #0084FF !important;
					// border-color: #0084FF !important;
					// border-radius: 10px !important;
				}
			}
		}


	}

	.elDialogContainer {

		.ipt {
			width: 560px;
			// display: flex;
			// align-items: center;
			margin-bottom: 28px;

			.text {
				// width: 135px;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: 16px;
				color: #000;
				margin-bottom: 20px;
			}

			.el-input {
				flex: 1 !important;
			}

			.el-select {
				flex: 1 !important;
			}

			.el-textarea {
				flex: 1 !important;
			}




		}


	}

	.addressList {
		padding-top: 20px;

		.item {
			display: flex;
			align-items: center;
			border-bottom: 1px solid #EEEEEE;
			padding: 10px 20px;
			margin-bottom: 20px;

			.addressLeft {
				flex: 1;

				.top {
					font-weight: bold;
					font-size: 16px;
					color: #343232;
					margin-bottom: 5px;
				}

				.bottom {
					font-weight: 500;
					font-size: 16px;
					color: #343232;
				}
			}

			.addressRight {
				font-size: 0;
				cursor: pointer;

				img {
					width: 20px;
					height: 20px;
				}
			}
		}

		.ipt {
			width: 700px;
			display: flex;
			align-items: center;
			margin-bottom: 28px;

			.text {
				// width: 135px;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: 18px;
				color: #333333;
				margin-right: 20px;
			}

			.el-input {
				flex: 1 !important;
			}

			.el-select {
				flex: 1 !important;
			}

			.el-textarea {
				flex: 1 !important;
			}

			.el-date-editor {
				flex: 1 !important;
			}

			.el-cascader {
				flex: 1 !important;
			}
		}
	}


	.previewElDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #FFFFFF;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2A2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 50px;
			// width: 410px;
			// height: 390px;
			background: #FFFFFF;
			border-radius: 10px;
			border: 4px solid #0084FF;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcodeImage {
				position: relative;
				width: 208px;
				height: 245px;
			}

			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}

			.qrcodeLogo {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				width: 90px;
				height: 90px;
				border-radius: 50%;
				margin: 58px auto;
			}

			.hite1 {
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}
		}
	}
</style>

<style>
	#corporateImage .previewDialogVisible1 .preview .el-dialog {
		background: #fff !important;
		box-shadow: 0 1px 3px rgba(0, 0, 0, .3) !important;
	}

	#corporateImage .previewDialogVisible1 .el-dialog {
		background: initial;
		box-shadow: initial;
	}

	#corporateImage .el-input__inner {
		font-size: 14px !important;
	}

	#corporateImage .companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	#corporateImage .avatarContainer .avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	#corporateImage .avatarContainer .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	#corporateImage .avatarContainer .avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	#corporateImage .avatarContainer .avatar-uploader-icon1 {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	#corporateImage .avatarContainer .avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 120px;
		height: 120px;
		display: block;
	}


	.environment {
		border: 1px solid #DCDFE6;
		flex: 1;
		background-color: #FFF;
		color: #606266;
		height: 40px;
		padding: 0 15px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 40px;
	}




	#corporateImage .avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		background: #fbfdff;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	#corporateImage .enterprise .avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	#corporateImage .enterprise .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
		margin-bottom: 0;
	}

	.avatar-uploader1 .el-upload:hover {
		border-color: #409EFF;
	}


	#corporateImage .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 120px;
		height: 120px;
		line-height: 120px;
		text-align: center;
	}

	#corporateImage .avatar {
		width: 120px;
		height: 120px;
		display: block;
	}

	#corporateImage .storefrontSignboard .avatar {
		width: 120px;
		height: 120px;
		display: block;
	}

	.avatar1 {
		width: 120px;
		height: 120px;
		display: block;
	}

	.avatar5 {
		width: 80px;
		height: 80px;
	}
</style>
